/*
  eslint-disable
  import/no-dynamic-require,
  global-require,
  no-undef,
  consistent-return,
  react/jsx-filename-extension
*/
import React from 'react';

import AnimationsSettingsContextWrapper from './src/components/AnimationsSettingsContextWrapper';

export function wrapPage({ element, props }, { enabled, pageTransition }) {
  return (
    <AnimationsSettingsContextWrapper {...props} enabled={enabled} pageTransition={pageTransition}>
      {element}
    </AnimationsSettingsContextWrapper>
  );
}
